export default __webpack_public_path__ + "static/news1-ef93568efa5cadbf6658db416c29dbd5.png";